import { render, staticRenderFns } from "./ci-jobs-table.vue?vue&type=template&id=0947b26e&scoped=true&"
import script from "./ci-jobs-table.vue?vue&type=script&lang=js&"
export * from "./ci-jobs-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0947b26e",
  null
  
)

export default component.exports